import { useCheckList } from "./CheckListContext"

const DeleteButton = ({rec}) => {
    const {deleteRec} = useCheckList()

    const clickHandler = (event) => {
        event.preventDefault()
        if (window.confirm(`Are you sure you wish to delete ${rec.label} (and all of it's children?`)) {
            deleteRec(rec)
        }
    }
    return (
        <button
            type="button"
            className="delete-btn"
            onClick={clickHandler}
        >
            X
        </button>
    )
}

export default DeleteButton